export default function TechyThumbnail() {
  return (
    <svg
      viewBox="0 0 104 86"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      preserveAspectRatio="xMidYMid slice"
      width="100%"
      height="100%"
    >
      <rect width="104" height="86" fill="#1F2022" />
      <rect
        opacity="0.9"
        x="81.5"
        y="63.5"
        width="66.6362"
        height="50.4498"
        transform="rotate(-180 81.5 63.5)"
        fill="#87FF85"
        stroke="black"
      />
      <g opacity="0.9">
        <rect
          x="90.5"
          y="72.5"
          width="66.6362"
          height="50.4498"
          transform="rotate(-180 90.5 72.5)"
          fill="white"
        />
        <rect
          x="90.5"
          y="72.5"
          width="66.6362"
          height="50.4498"
          transform="rotate(-180 90.5 72.5)"
        />
        <rect
          x="90.5"
          y="72.5"
          width="66.6362"
          height="50.4498"
          transform="rotate(-180 90.5 72.5)"
          stroke="black"
        />
      </g>
    </svg>
  );
}
